export const CitationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.9 4.66667H9.1V3.33333H3.9V4.66667ZM1.235 4C1.235 2.46667 2.405 1.26667 3.9 1.26667H5.85V0H3.9C1.755 0 0 1.8 0 4C0 6.2 1.755 8 3.9 8H5.85V6.73333H3.9C2.405 6.73333 1.235 5.53333 1.235 4ZM9.1 0H7.15V1.26667H9.1C10.595 1.26667 11.765 2.46667 11.765 4C11.765 5.53333 10.595 6.73333 9.1 6.73333H7.15V8H9.1C11.245 8 13 6.2 13 4C13 1.8 11.245 0 9.1 0Z"
      fill="currentColor"
    />
  </svg>
);
